//TODO: move everything from "notificationFilter" here eventually
//to have a general global filterButtons reducer
import {
  IncidentPriority,
  IncidentStatus,
} from '@energybox/react-ui-library/dist/types';

export enum Actions {
  INCIDENT_PRIORITY = '@@filters/INCIDENT_PRIORITY',
  INCIDENT_STATUS = '@@filters/INCIDENT_STATUS',
  SITE = '@@filters/SITE',
  EQUIPMENT = '@@filters/EQUIPMENT',
}

export const setIncidentPriorityFilter = (priorities: IncidentPriority[]) => ({
  type: Actions.INCIDENT_PRIORITY,
  payload: priorities,
});

export const setIncidentStatusFilter = (statuses: IncidentStatus[]) => ({
  type: Actions.INCIDENT_STATUS,
  payload: statuses,
});

export const setSiteFilter = (siteIds: number[]) => ({
  type: Actions.SITE,
  payload: siteIds,
});

// TODO: should Type stay in this name? separate action for item group or ??
export const setEquipmentTypeFilter = (equipmentTypeIds: number[]) => ({
  type: Actions.EQUIPMENT,
  payload: equipmentTypeIds,
});
